import { HTMLAttributes } from 'react';
import styles from './styles.module.scss';
import { addThousandsSeparators } from '../../utils';
import { CurrencySymbol, PricingVariant } from './enums';

export type PricingProps = HTMLAttributes<HTMLDivElement> & {
  price: number;
  hideCents?: boolean;
  variant?: PricingVariant;
  symbol?: CurrencySymbol;
};

export const Pricing = ({
  price,
  hideCents = false,
  variant = PricingVariant.Default,
  symbol: currencySymbol = CurrencySymbol.Dollar,
}: PricingProps) => {
  // We must round in case we get a fractional cents value.
  const priceString = Math.round(Math.abs(price)).toString();

  const isNegative = price < 0;
  const sign = isNegative ? '-' : '';
  const wholePrice = addThousandsSeparators(priceString.slice(0, priceString.length - 2)) || '0';
  const fractionalPrice = priceString.slice(-2).padEnd(2, '0');

  if (variant === PricingVariant.Featured) {
    return (
      <div className={`${styles.pricing} ${styles.variantFeatured}`}>
        {isNegative && <span className={styles.sign}>{sign}</span>}
        <span className={styles.currencySymbol}>{currencySymbol}</span>
        <span className={styles.wholePrice}>{wholePrice}</span>
        {!hideCents && <span className={styles.fractionalPrice}>.{fractionalPrice}</span>}
      </div>
    );
  }

  if (variant === PricingVariant.Spaced) {
    return (
      <span
        className={styles.pricing}
      >{`${currencySymbol ?? '$'} ${sign}${wholePrice}${hideCents ? '' : `.${fractionalPrice}`}`}</span>
    );
  }

  return (
    <span
      className={styles.pricing}
    >{`${sign}${currencySymbol}${wholePrice}${hideCents ? '' : `.${fractionalPrice}`}`}</span>
  );
};
